import { render, staticRenderFns } from "./addTaskModal.vue?vue&type=template&id=1b5293e9&"
import script from "./addTaskModal.vue?vue&type=script&lang=js&"
export * from "./addTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports